import actions from './general/action-types';
import mutations from './general/mutation-types';
import getters from './general/getter-types';

export default {
  actions,
  mutations,
  getters,
};
